import React, { useState } from 'react';
import { PenTool, Home, Briefcase, ArrowUpRight } from 'lucide-react';

const Services = () => {
  const [activeId, setActiveId] = useState(1); // Default second card open

  // SEO UPDATED DATA: Delhi, Lucknow, Varanasi
  const services = [
    {
      id: 0,
      title: "Luxury Interiors Delhi", // Keyword: Location
      category: "RESIDENTIAL DESIGN",
      desc: "Transforming homes in South Delhi and Noida into modern palaces. We specialize in master suites, Italian marble flooring, and royal living areas.",
      icon: <Home size={32} />,
      img: "https://www.designdekko.com/uploads/featured/1669966804-SRP41.jpg"
    },
    {
      id: 1,
      title: "Construction Lucknow", // Keyword: Service + Location
      category: "TURNKEY BUILDERS",
      desc: "End-to-end home construction and renovation in Lucknow. From civil structure to final interior finishing, we build legacy homes that last generations.",
      icon: <Briefcase size={32} />, // Represents Professional Turnkey Service
      img: "https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&q=80"
    },
    {
      id: 2,
      title: "Vastu Planning Varanasi", // Keyword: Niche + Location
      category: "ARCHITECTURE & MAPS",
      desc: "Scientific Vastu-compliant house maps and 3D elevations. We design positive energy homes perfectly suited for Varanasi and Ayodhya regions.",
      icon: <PenTool size={32} />, // Represents Planning/Drawing
      img: "https://images.unsplash.com/photo-1556228453-efd6c1ff04f6?auto=format&fit=crop&q=80"
    }
  ];

  return (
    <div className="bg-neutral-50 min-h-screen flex flex-col items-center justify-center py-20 px-4 md:px-8 font-sans">
      
      {/* Section Header */}
      <div className="text-center mb-16 max-w-2xl">
        <h3 className="text-amber-600 tracking-[0.3em] text-sm font-bold uppercase mb-4">
          Our Expertise
        </h3>
        <h2 className="text-5xl md:text-6xl font-serif text-neutral-900 mb-6">
          Premium <span className="italic text-amber-500">Services</span>
        </h2>
        <p className="text-gray-500">
          Comprehensive design and build solutions across Delhi NCR, Lucknow & Varanasi.
        </p>
      </div>

      {/* Unique Expandable Gallery Layout - SAME STRUCTURE */}
      <div className="w-full max-w-7xl h-[450px] flex flex-col md:flex-row gap-4">
        {services.map((service, index) => (
          <div
            key={service.id}
            onClick={() => setActiveId(index)}
            onMouseEnter={() => setActiveId(index)}
            className={`relative rounded-3xl overflow-hidden cursor-pointer transition-all duration-700 ease-in-out shadow-2xl
              ${activeId === index ? 'flex-[3]' : 'flex-[1]'}
            `}
          >
            {/* Background Image */}
            <div 
              className="absolute inset-0 bg-cover bg-center transition-transform duration-1000 scale-105"
              style={{ backgroundImage: `url(${service.img})` }}
            >
              {/* Overlay Gradient */}
              <div className={`absolute inset-0 bg-gradient-to-t from-black/90 via-black/20 to-transparent ${activeId === index ? 'opacity-80' : 'opacity-60'}`}></div>
            </div>

            {/* Content Container */}
            <div className="absolute inset-0 p-8 flex flex-col justify-between text-white">
              
              {/* Top: Icon & Number */}
              <div className="flex justify-between items-start">
                <div className={`bg-white/10 backdrop-blur-md p-3 rounded-full text-amber-400 border border-white/20 transition-all duration-500 ${activeId === index ? 'translate-y-0 opacity-100' : '-translate-y-4 opacity-0'}`}>
                  {service.icon}
                </div>
                <span className="text-4xl font-serif text-white/20 font-bold">0{index + 1}</span>
              </div>

              {/* Bottom: Text Info */}
              <div className="relative">
                {/* Vertical Text for Inactive Cards (Desktop Only) */}
                <div className={`hidden md:block absolute bottom-0 left-0 origin-bottom-left -rotate-90 w-[400px] transition-opacity duration-300 ${activeId === index ? 'opacity-0 pointer-events-none' : 'opacity-100'}`}>
                  <h3 className="text-2xl font-serif tracking-wide text-white whitespace-nowrap">{service.title}</h3>
                </div>

                {/* Expanded Content */}
                <div className={`transition-all duration-500 transform ${activeId === index ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0 hidden'}`}>
                  <p className="text-amber-400 tracking-widest text-xs uppercase font-bold mb-2">{service.category}</p>
                  <h3 className="text-3xl md:text-5xl font-serif mb-4 leading-tight">{service.title}</h3>
                  <p className="text-gray-300 max-w-md text-sm md:text-base leading-relaxed mb-6 border-l-2 border-amber-500 pl-4">
                    {service.desc}
                  </p>
                  <button className="flex items-center gap-2 bg-white text-neutral-900 px-6 py-3 text-xs font-bold uppercase tracking-wider hover:bg-amber-500 hover:text-white transition-colors duration-300">
                    Get Quote <ArrowUpRight size={16} />
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Decorative Bottom Line */}
      <div className="mt-20 flex items-center gap-4 opacity-30">
        <div className="h-[1px] w-24 bg-neutral-900"></div>
        <div className="w-2 h-2 rounded-full bg-neutral-900"></div>
        <div className="h-[1px] w-24 bg-neutral-900"></div>
      </div>
    </div>
  );
};

export default Services;